import appConfig from "../config/app";

const configHostname = (() => {
  try {
    return new URL(`https://${appConfig.quickRepliesCloudFrontUrl}`).hostname;
  } catch {
    return appConfig.quickRepliesCloudFrontUrl;
  }
})();

const isValidUrl = (url: string): boolean => {
  if (!url || url === '') return false;
  if (url.startsWith('blob:') || url.startsWith('data:')) return false;

  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

export const getUrlWithToken = (url: string, token: string) => {
  if (!isValidUrl(url) || token === '') return url;
  try {
    const urlObj = new URL(url);
    if(urlObj.hostname === configHostname) {
      urlObj.searchParams.set('token', encodeURIComponent(token));
    }

    return urlObj.toString();
  } catch (error) {
    console.error('Error parsing URL:', error);
    return url;
  }
};
